import { render, staticRenderFns } from "./OsteopathyFemaleBody.vue?vue&type=template&id=6f825d11&"
import script from "./OsteopathyFemaleBody.vue?vue&type=script&lang=js&"
export * from "./OsteopathyFemaleBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports